const vapourvape = {
    id: 'vapourvape',
    publicSiteName: 'Vapour Vape',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#0f3857',
            secondary: '#000000',
            color1: '#2c8fda',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapourvape/favicon.ico',
        logo: '/vapourvape/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapourvape